export default "__VITE_ASSET__Cq48IK2I__"